import React from 'react'
import InlineSelectEditor from '../../inline-editors/InlineSelectEditor'
import { formatDamageHistory } from '../utils'
import { CellBaseProps, resolveOverrideContext, isFieldEditing, makeEditClickHandler, makeFieldSaveHandler, overrideEditableClass } from './types'

/**
 * Renders the Damage History (DMG) column cell.
 */
export function DamageCell(props: CellBaseProps) {
  const { cellBorderClass, effectiveAircraft, aircraftTransaction } = props
  const { isSoldWithTransaction, isEditable, transOverride, override } = resolveOverrideContext(props)

  const hasOverride = isSoldWithTransaction
    ? (transOverride?.damage_history != null)
    : (override?.damage_history != null)

  const currentValue = isSoldWithTransaction
    ? (transOverride?.damage_history ?? aircraftTransaction!?.damage_history ?? null)
    : (override?.damage_history ?? null)

  const isEditing = isFieldEditing(props, 'damage_history', isSoldWithTransaction)

  return (
    <td className={`px-2 py-2 text-sm text-gray-900 text-center ${cellBorderClass} relative`}>
      <>
        <div
          className={overrideEditableClass(hasOverride, isEditable)}
          onClick={makeEditClickHandler(props, 'damage_history', isEditable, isSoldWithTransaction)}
        >
          {formatDamageHistory(effectiveAircraft.damagehistoryyn)}
        </div>
        {isEditing && (
          <InlineSelectEditor
            value={currentValue}
            fieldName="DMG"
            options={[
              { value: 'Yes', label: 'YES' },
              { value: 'No', label: 'NO' },
              { value: 'Unknown', label: 'UNK' }
            ]}
            title="Select Damage History"
            onSave={makeFieldSaveHandler(props, 'damage_history', isSoldWithTransaction)}
            onCancel={props.handleCancelEdit}
            allowClear={true}
          />
        )}
      </>
    </td>
  )
}

